import React from "react";
import { TopNavBar } from "./navigation/top-nav-bar";
import { PageFooter } from "./page-footer";

export const PageLayout = ({ children }) => {
  return (
    <div className="page-layout">
      <TopNavBar />
      <div className="page-layout__content">{children}</div>
      <PageFooter />
    </div>
  );
};
